import { Header } from '@/components/Header';
import { GuestDetailsSection } from '@/components/forms/GuestDetailsSection';
import { Button } from '@/components/ui/button';
import { ToastNotification } from '@/components/ui/ToastNotification';
import { useGuestForm } from '@/lib/hooks/useGuestForm';
import { RegisterGuestContent } from '@/content/RegisterGuestContent';

export function RegisterGuest() {
  const {
    form,
    isSuccess,
    submitAttempted,
    validationErrors,
    handleDone,
    toast,
    hideToast,
  } = useGuestForm();

  // Show success state
  if (isSuccess) {
    return (
      <>
        <div className="flex flex-col">
          <Header enableBack />
          <div className="w-full max-w-4xl mx-auto px-4 pb-12">
            <div className="mb-2 w-full text-center">
              <h1 className="text-h2">{RegisterGuestContent.successTitle}</h1>
            </div>

            <div className="flex flex-col items-center justify-center space-y-6">
              <div className="text-center space-y-2">
                <p className="text-body text-foreground/80">
                  {RegisterGuestContent.successMessage}
                </p>
              </div>

              <Button
                onClick={handleDone}
                variant="default"
                className="w-full h-16 mt-auto"
              >
                {RegisterGuestContent.done}
              </Button>
            </div>
          </div>
        </div>

        {/* Toast Notification */}
        <ToastNotification
          open={toast.open}
          onClose={hideToast}
          title={toast.title}
          description={toast.description}
          variant={toast.variant}
          position="bottom"
        />
      </>
    );
  }

  // Show form
  return (
    <>
      <div className="flex flex-col">
        <Header enableBack />
        <div className="w-full max-w-4xl mx-auto px-4 pb-12">
          <div className="mb-2">
            <h1>{RegisterGuestContent.pageTitle}</h1>
            <p className="text-body text-slate-200 pb-3">
              {RegisterGuestContent.pageDisclaimer}
            </p>
          </div>

          <form
            id="guest-form"
            className="space-y-6"
            onSubmit={(event) => {
              event.preventDefault();
              void form.handleSubmit();
            }}
          >
            <GuestDetailsSection
              form={form}
              submitAttempted={submitAttempted}
              validationErrors={validationErrors}
            />
          </form>
        </div>
      </div>

      {/* Toast Notification */}
      <ToastNotification
        open={toast.open}
        onClose={hideToast}
        title={toast.title}
        description={toast.description}
        variant={toast.variant}
        position="bottom"
      />
    </>
  );
}

